import { Helmet } from 'abi'

export * from './ext'

import { _day_to_image } from './day'
import { _tejaratno_to_image } from './tejaratno'

export async function helmet_to_image(helmet: Helmet): Promise<Blob> {
    if (helmet.provider == 'day') return _day_to_image(helmet)

    return _tejaratno_to_image(helmet)
}
